import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-button',
  templateUrl: './reports-button.component.html',
  styleUrls: ['./reports-button.component.scss']
})
export class ReportsButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
